function traverse(obj, callback, parent = null, key = null, visited = /* @__PURE__ */ new WeakSet()) {
  if (obj == null || typeof obj !== "object") {
    callback(obj, (newValue) => {
      if (parent !== null && key !== null)
        parent[key] = newValue;
    });
    return;
  }
  if (visited.has(obj))
    return;
  visited.add(obj);
  if (Array.isArray(obj))
    obj.forEach((item, index) => {
      const update = (newValue) => {
        obj[index] = newValue;
      };
      callback(item, update);
      traverse(item, callback, obj, index, visited);
    });
  else
    Object.entries(obj).forEach(([key2, value]) => {
      const update = (newValue) => {
        obj[key2] = newValue;
      };
      callback(value, update);
      traverse(value, callback, obj, key2, visited);
    });
}
export {
  traverse
};
